import React, { Component } from 'react';

import {
  Page,
  Card,
  Layout,
  SkeletonBodyText,
  Button,
  Pagination,
  Toast,
  SkeletonPage,
  BlockStack,
  Link,
  Select,
  Modal,
  InlineStack,
  Checkbox,
  Box,
  Popover,
  Icon,
  OptionList
} from "@shopify/polaris";

import {
  ChevronLeftMinor,
  SortMinor
} from '@shopify/polaris-icons';
import utils from '../../../../utils/utils'
import { withRouter } from 'react-router-dom';
import LazyLoad from 'react-lazyload';
import AppBridge from '../../../../utils/appBridge';

import { 
  getGetProductAddSuccess,
  reqGetFindHolidayProductsList,reqGetUserSubcribe,reqGoogleAnalytics,reqPostAddProductToList
} from '../../../../api';
import ImportDsmModal from '../../SubscriptionPaid/components/ImportDsmModal';
import '../index.css';
import intl from "../../../../i18n/intl";
import { store } from '../../../../store';
// import { connect} from "react-redux";
import { changeBannerData, changePersonLevel } from '../../../../slice';

class RecommendedCategory extends Component {
  state = {
    pageTitle: 'Products',
    // 产品导入成功弹窗
    chargeError:false,
    
    sortBy: '',

    // 列表原始数据
    pageData: [],
    // DIV列表数据
    ListDivHtml: <div></div>,

    loadingPage: false,
    isSearching: '0',
    page: 1,
    size: 36,
    pageValue: "",
    hasPrevious: false,
    hasNext: true,
    ShowCountNumber: 0,
    holidayData:[
      {
        label:'All',
        value:''
      }
    ],//节日类别
    currentHoliday:'', // 默认节日
    importantLimit:0,//商品导入限制
    importantDsmModal:false,//dsm产品导入限制
    importantDay:3,//每天限定导入
    productAddSuccess:false, // 是否不再显示导入成功弹窗
    selectAgain:false ,// 选择不再弹窗
    popoverSort:false,
  };

  //进入页面调用接口
  componentDidMount() {
    let title = intl.get("Event Products");
    if(AppBridge && AppBridge.exist()) {
      AppBridge.setTitleBar('Event Products','/admin/find_products')
    }
    window.onscroll = this.onScroll;
    document.documentElement.style.scrollBehavior="smooth";
    let url = new URLSearchParams(this.props.history.location.search);
    let text = url.get('holiday');
    this.setState({
      pageTitle: title,
      currentHoliday:text ? text : this.state.currentHoliday
    }, () => {
      this.getPageData();
      
    })
  }

  onScroll = () => {
    let obj = document.getElementById('showTopButton');
    if (obj) {
      if (document.documentElement.scrollTop > 250 ) {
        obj.style.display = 'block';
      }
      if (document.documentElement.scrollTop < 250) {
        obj.style.display = 'none';
      }
    }
  }

  scrollToTop = () => {
    document.documentElement.scrollTop = 0
  }

  toggleToast = (showToastText, showToastIserror=false) => {
    this.setState(({ showToast }) => ({
      showToast: !showToast,
      showToastText: showToastText,
      showToastIserror: showToastIserror
    }));
  };
  // 获取列表数据
  getPageData = async(isSearch=false,) =>{
    if(isSearch){
      this.setState({
        isSearching:'1',
        hasPrevious : false,
        hasNext : false,
      });
    }else{
      this.setState({
        loadingPage: true,
        hasPrevious : false,
        hasNext : false,
      });
    }
    
    const params = {
      page: this.state.page,
      size: this.state.size,
      sort_by: this.state.sortBy,
      holiday:this.state.currentHoliday
      // recommended: 'trendy'
    };
    // store.subscribe(()=>{
    //   let person = store.getState().languageReducer?.subScriptData;
    //   if (person?.level < 2) {
    //     // 标识错误，直接返回
    //     this.props.history.push('/admin/dashboard');
    //     return false;
    //   }
    // })
    const response = await reqGetFindHolidayProductsList(params);
    
    if(response.code==='200'){
      let person = store.getState().languageReducer.subScriptData;
      if (Object.values(person).length > 0) {
        this.setState({
          productAddSuccess:person?.bfs_pop?.is_bfs_import_product ? person?.bfs_pop?.is_bfs_import_product : false
        })
      }
      let res = await reqGetUserSubcribe();
      if (res.code === '200') {
        this.setState({
          importantLimit:Number(res?.data?.limit?.dsm),
          importantDay:Number(res?.data?.day?.dsm)
        })
      }
      // 清除浏览器链接上的参数
      try {
        var currentUrl = window.location.href;
        if (currentUrl.indexOf("?") !== -1) {
          currentUrl = currentUrl.replace(/(\?|#)[^'"]*/, '');
          if (!!(window.history && window.history.pushState)) {
            window.history.pushState({}, 0, currentUrl);
          }
        }
      } catch (error) {
        console.warn(error);
      }
      let getData = response.data;

      this.setState({
        loadingPage: false,
        pageData: getData.result,
        total: getData.count,
        ShowCountNumber: getData.count,
        isSearching: '0',
        pageValue:"",
        holidayData:getData.holiday
      },()=>{
        // 更新列表数据
        this.updatePageDetail();
      });

      // 更新分页数据
      if(this.state.page > 1){
        this.setState({
          hasPrevious:true
        });
      }else{
        this.setState({
          hasPrevious:false
        });
      }

      const maxPage =  Math.ceil(response.data.count / this.state.size);
      if(this.state.page < maxPage){
        this.setState({
          hasNext:true,
          PageCount:maxPage
        });
      }else{
        this.setState({
          hasNext:false,
          PageCount:maxPage
        });
      }

    }else{
      // this.toggleToast(response.msg,true);
      store.dispatch(changeBannerData({bannerData:{
        show:true,
        desc:response.msg
      }}));
      this.setState({
        loadingPage: false,
        pageData: [],
        isSearching: '0',
      });
    }
  }

  // 更新列表信息
  updatePageDetail(){
    let data = this.state.pageData;
    let listHtmlContent = <div></div>;

    if(data.length > 0){
      listHtmlContent = data.map((item,key) => {
        let imageUrl = '/default_image.png';
        if(item.image_url !== '' && (typeof item.image_url) !=='object'){
          imageUrl = item.image_url;
        }

        let discountRangeClass = '';
        let compared_price = item.compared_price;
        let discount_rate  = item.discount_rate;
        
        if (discount_rate !== 0 && compared_price !== '') {
          let split = compared_price.split('-');
          if (split.length === 2) discountRangeClass = 'discountRange';
        }

        return (
          <div className="Product_Card_Tkabk find_product" key={key}>
            <div className={"buttonHover " + discountRangeClass}>
            <Card padding={0}>
              <div className="Product_Image_Wrapper Product_Cover_Tkabk" style={{width:'246px',height:'246px'}}>
                <div onClick={()=>this.handleJumpToDetail(item.id)} style={{cursor:'pointer',width:'100%',height:'100%'}}>
                  <LazyLoad once>
                    <img src={imageUrl} alt="" onClick={()=>{
                      //Search Product页面产品封面点击gtag
                      reqGoogleAnalytics('click', 'searchproduct_productpicture_click');
                    }}/>
                  </LazyLoad>
                </div>
                { (discount_rate > 0) ? (
                  <div className='discount'>
                    {'-' + discount_rate + '%'}
                  </div>
                ) : ''}
              </div>

                 
                <div style={{padding:'20px'}}>
                  <div className="Product_Title_tkabk" title={item.title}>
                    {item.title}
                  </div>
                  <div style={{margin:'10px 0'}}>
                  <InlineStack align="space-between">
                    <span className="Product_Rating_tkabk">
                      <svg viewBox="0 0 20 20">
                        <path d="M5.2 18a.8.8 0 0 1-.792-.914l.743-5.203-2.917-2.917a.8.8 0 0 1 .434-1.355l4.398-.733 2.218-4.435a.8.8 0 0 1 1.435.008l2.123 4.361 4.498.801a.8.8 0 0 1 .425 1.353l-2.917 2.917.744 5.203a.8.8 0 0 1-1.154.828l-4.382-2.22-4.502 2.223A.792.792 0 0 1 5.2 18z"></path>
                      </svg>
                      {item.rating+' ('+item.evaluation_count+')'}
                    </span>
                    <span className="Product_Orders_tkabk">
                    <svg viewBox="0 0 20 20">
                      <path d="M11 1a1 1 0 1 0-2 0v7.586L7.707 7.293a1 1 0 0 0-1.414 1.414l3 3a1 1 0 0 0 1.414 0l3-3a1 1 0 0 0-1.414-1.414L11 8.586V1z"></path>
                      <path d="M3 14V3h4V1H2.5A1.5 1.5 0 0 0 1 2.5v15A1.5 1.5 0 0 0 2.5 19h15a1.5 1.5 0 0 0 1.5-1.5v-15A1.5 1.5 0 0 0 17.5 1H13v2h4v11h-3.5c-.775 0-1.388.662-1.926 1.244l-.11.12A1.994 1.994 0 0 1 10 16a1.994 1.994 0 0 1-1.463-.637l-.111-.12C7.888 14.664 7.275 14 6.5 14H3z"></path>
                    </svg>
                      {' '+item.order_count}
                  </span>
                  </InlineStack>
                  </div>
                  <div className='Product_Price_Value'>
                    <div className='Product_Title_Money'>{item.price}</div>

                    { compared_price && (
                      <div className='Product_Compare_at_price_tkabk'>
                          {'('+ compared_price +')'}
                      </div>
                    )}
                  </div>
                </div>

                <BlockStack>
                  <div className="Place_Order_Button" >
                    { item.pid ? (
                        <Button
                            id={"btn2"}
                            onClick={()=>this.handleToSourcingList(key, item.id, item.pid)}
                            fullWidth
                          
                        >
                          Edit on product list
                        </Button>
                    ) : (

                        <Button
                            id={"btn1"}
                            onClick={()=>this.handleToSourcingList(key, item.id, 0)}
                            fullWidth
                            variant='primary'
                            loading={!!item.loading}
                        >
                          Add to product list
                        </Button>

                    ) }
                  </div>
                </BlockStack>

                 

            </Card>
            </div>
          </div>
        );
      });
    }

    this.setState({
      ListDivHtml: listHtmlContent,
      ShowCountNumber: data.length,
    });
  }

  // 页面操作
  handleToSourcingList = async (recordKey,productId,userProductId) => {
    if(userProductId !== 0){  // 跳转到sourcing - product 页面
        utils.routeListen('/admin/import-list')
        utils.routeJump(this,'/admin/import-list?ids='+userProductId)
      return;

    } else {
      let person = store.getState().languageReducer.subScriptData;
      // 导入限制
      if ((person.level === 0 && this.state.importantLimit >= 3 )||  (person?.level ===4 && this.state.importantLimit >= 100)) {
        this.setState({importantDsmModal:true})
        return;
      }

      //Search Product页面Add to products list按钮点击gtag
      reqGoogleAnalytics('click', 'searchproduct_importproduct_click');
      
      // 产品导入到 sourcing - product列表
      let data = this.state.pageData;
      data[recordKey].loading = 1;
      this.setState({
        pageData: data,
      },()=>{
        this.updatePageDetail();
      })

      const params = {
        id: productId,
      };
      const response = await reqPostAddProductToList(params);
      if (response.code === '200') {
        // this.toggleToast(response.msg,false);
        this.setState({importantLimit:this.state.importantLimit+1})
        data[recordKey].pid = response.data;
        data[recordKey].loading = 0;

        this.setState(
          {
            pageData: data,
            chargeError:this.state.productAddSuccess ? false : true,
          },
          () => {
            if (this.state.productAddSuccess) {
              this.toggleToast("Added successfully")
            } 
            this.updatePageDetail();
          }
        );

      } else {
        // this.toggleToast(response.msg,true);
        store.dispatch(changeBannerData({bannerData:{
          show:true,
          desc:response.msg
        }}));
      }
    }
  }


  /**
   * 判断链接跳转
   * 
   * 说明：如果 AppBridge实例存在代表Shopify内嵌模式，否在代表Shopify站外访问
   * 
   * @param {string} uri 路由，没有携带域名
   */
   handleJumpLink = (uri) => {
    if (AppBridge.exist()) {
      utils.routeListen(uri)
      utils.routeJump(this,uri)
    } else {
      try {
        // 获取当前域名
        // let localHost = window.location.protocol + "//" + window.location.hostname + (window.location.port ? ':' + window.location.port : '');

        // const w = window.open('about:blank');
        // w.location.href = localHost + uri;
        utils.routeListen(uri)
        utils.routeJump(this,uri)
      } catch (error) {
        utils.routeListen(uri)
        utils.routeJump(this,uri)
      }
    }
  }

  // 跳转到产品详情页面
  handleJumpToDetail = (id,count) => {
    this.handleJumpLink('/admin/find_products/product-info?filter='+id+'&holiday='+1);
    return false;
  }

  // select change
  handleSelectChange = (value) =>{
    this.setState({
      sortBy: value[0],
      page: 1,
    },()=>{
      setTimeout(() => {
        this.getPageData(true);
      }, 600);
    })
  }
  // select change
  handleSelectChangeHoliday = (value) =>{
    this.setState({
      sortBy: '',
      page: 1,
      currentHoliday:value
    },()=>{
      setTimeout(() => {
        this.getPageData(true);
      }, 600);
    })
  }

  callChargeErrorClosed = () => {
    this.setState({
      chargeError: false,
    },()=>{
      if (!this.state.productAddSuccess && this.state.selectAgain) {
        this.selectAgainClose()
      }
    });
  };
   // 不再弹出导入成功弹窗
   selectAgainClose = async () => {
    try {
      let res = await getGetProductAddSuccess()
      if (res.code === '200') {
        let getData = store.getState().languageReducer.subScriptData;
        this.props.dispatch(changePersonLevel({infoData:{...getData,bfs_pop:{...getData.bfs_pop,is_bfs_import_product:true}}},true))
        this.setState({
          productAddSuccess:true
        })
      }
    } catch (error) {
      
    }
  };

  render() {
    const toastMarkup = this.state.showToast ? <Toast content={this.state.showToastText} onDismiss={()=>this.toggleToast('')} error={this.state.showToastIserror} /> : null;

    const {
      isSearching, pageTitle, ShowCountNumber, ListDivHtml,holidayData
    } = this.state;

    const initSkeletonPage = (
      <div>
         <SkeletonPage fullWidth={true}>
          <Layout>
          <Layout.Section>
          <Card>
          <BlockStack gap={400}>
          <SkeletonBodyText lines={3}/>
          <SkeletonBodyText lines={3}/>
          <SkeletonBodyText lines={3}/>
          <SkeletonBodyText lines={3}/>
          <SkeletonBodyText lines={3}/>
          <SkeletonBodyText lines={3}/>
          <SkeletonBodyText lines={3}/>
          <SkeletonBodyText lines={3}/>
          <SkeletonBodyText lines={3}/>
          <SkeletonBodyText lines={3}/>
          <SkeletonBodyText lines={3}/>
          <SkeletonBodyText lines={3}/>
          <SkeletonBodyText lines={3}/>
          </BlockStack>
          </Card>
        </Layout.Section>
          </Layout>
        </SkeletonPage>
      </div>
    )

    const sortOptions = [
      {label: intl.get("Newest to oldest"), value: ''},
      {label: intl.get("Price:low to high"), value: 'price_asc'},
      {label: intl.get("Price:high to low"), value: 'price_desc'},
      {label: intl.get("Rating:high to low"), value: 'rating_desc'}
    ];

    // 产品导入成功提示
    const SingleOperationTipsModal =
    (
      <Modal
      open={this.state.chargeError}
      onClose={this.callChargeErrorClosed}
      title={intl.get("Product imported successfully")}
    >
      <Box className='product_success_content'>
        <div style={{ fontSize: "16px", color: "#202223",padding:"16px" }}>
        {intl.get("You can go to the")}{" "}
          <span style={{ fontSize: "16px",fontWeight:700, color: "#303030" }}>
            {intl.get("List Products > Not Listed")}
          </span>{" "}
          {intl.get("to view and edit the product.")}
        </div>
        
        <Box className='product_success_button'>
        <Checkbox
              checked={this.state.selectAgain}
              label={intl.get("Don't remind me again")}
              onChange={()=>this.setState(({
                selectAgain:!this.state.selectAgain
              }))}
            />
          <Button variant="primary" onClick={this.callChargeErrorClosed}>
          {intl.get("OK")}
          </Button>
        </Box>
      </Box>
    </Modal>
    )

    // 空数据显示
    const EmptyProductList = (ShowCountNumber === 0) ? (
      <div style={{textAlign:"center",marginTop:'60px',minHeight:"650px"}}>
          <img src='/empty_gift.png' alt='dropshipman'/>
          <p style={{fontSize:'20px',opacity:'1',marginBottom:'0'}}>{intl.get("Related holiday products are coming soon, please stay tuned!")}</p>
      </div>
    ) : '';

    var footerContentMsg ='';
    if(this.state.total > 0){
      const startNum = (((this.state.page - 1) * this.state.size) + 1);
      const endNum   = (this.state.page * this.state.size>this.state.total)?this.state.total:this.state.page * this.state.size;
      // footerContentMsg = <div className="Pagination_Result__Footer">{"Showing " + startNum + " - "+ endNum + " of " + this.state.total + " results"}</div>;
      footerContentMsg = <div>{intl.get("Showing {{startNum}} - {{endNum}} of {{total}} results (Total {{PageCount}} pages)", startNum, endNum, this.state.total,this.state.PageCount)}</div>;
    }

    // 控制列表两个产品之间间距显示
    let smallSpacingClass = (ShowCountNumber <= 4) ? 'small_spacing' : '';

    const PaginationSettings = this.state.loadingPage ? '' :
        (ShowCountNumber !== 0) ?
            <div className="Polaris-New-Pagination">
                <Pagination
                  label={footerContentMsg}
                  hasPrevious = {this.state.hasPrevious}
                  onPrevious={() => {
                    this.setState(({page:Number(this.state.page) - 1}),()=>{
                      this.getPageData(true);
                    });
                  }}
                  hasNext = {this.state.hasNext}
                  onNext={() => {
                    this.setState(({page:Number(this.state.page) + 1}),()=>{
                      this.getPageData(true);
                    });
                  }}
              />
              <div>
              <input 
                className="Page_input" 
                type="text" 
                value={this.state.pageValue}  
                maxLength={"8"}
                onChange={(e)=>{
                  if(Number.isInteger(Number(e.target.value)) ){
                        this.setState({
                          pageValue:e.target.value
                        })
                  }
                }
                } />
                <span 
                  className="Page_Jump"
                  onClick={()=>{
                    if (this.state.PageCount === 1) return false;
                    let page = 1;
                    if(this.state.pageValue > this.state.PageCount){
                        page = this.state.PageCount
                    }
                    if(this.state.pageValue > 1 && this.state.pageValue <= this.state.PageCount){
                        page = this.state.pageValue
                    }
                    
                    this.setState({
                      page:page
                    },()=>{
                      this.getPageData(true)
                    })
                  }
                }>{intl.get("Go to")}</span>
              </div>
            </div> : '';

    const pageContent = this.state.loadingPage ? initSkeletonPage : (
      <Page fullWidth>
        <Layout>
          <Layout.Section>
          {AppBridge.exist() ?  <div className='right holiday_select_item' style={{display:'flex',justifyContent:'flex-end'}}>
                  <div style={{display:"flex",alignItems:'center',marginRight:"16px"}}>
                      <span className='span' style={{marginRight:8}}>{intl.get("Event")}:</span>
                      <Select
                      label={intl.get("Event")}
                      labelHidden
                      options={holidayData}
                      value={this.state.currentHoliday}
                      onChange={this.handleSelectChangeHoliday}
                    />
                  </div>
                  <div style={{display:"flex",alignItems:'center'}}>
                  <Popover
                  active={this.state.popoverSort}
                  activator={
                     <Button onClick={()=>this.setState({popoverSort:true})}>
                      <InlineStack blockAlign="center">
                  <Icon
                    source={SortMinor}
                    tone="base"
                  />
                 <span>{intl.get("Sort")}</span>
                  </InlineStack>
                  </Button>
                  }
                  autofocusTarget="first-node"
                  onClose={()=>this.setState({popoverSort:false})}
                >
                  <OptionList
                  title=""
                  onChange={this.handleSelectChange}
                  options={sortOptions}
                  selected={[this.state.sortBy]}
                />
                </Popover>
                </div>
                </div> :  <Card>
              <div className='recommended_category_Tab'>
                <div className='left'>
                  <div className='icon'>
                    <Button onClick={()=>{
                    utils.routeListen('/admin/find_products')
                    utils.routeJump(this,'/admin/find_products')}} icon={ChevronLeftMinor} variant='plain'></Button>
                  </div>
                  <div className='title'>{pageTitle}</div>
                </div>

                <div className='right holiday_select_item'>
                  <div style={{display:"flex",alignItems:'center',marginRight:"16px"}}>
                      <span className='span'>{intl.get("Event")}:</span>
                      <Select
                      label={intl.get("Event")}
                      labelHidden
                      options={holidayData}
                      value={this.state.currentHoliday}
                      onChange={this.handleSelectChangeHoliday}
                    />
                  </div>
                  <div style={{display:"flex",alignItems:'center'}}>
                  <Popover
                  active={this.state.popoverSort}
                  activator={
                     <Button onClick={()=>this.setState({popoverSort:true})}>
                      <InlineStack blockAlign="center">
                  <Icon
                    source={SortMinor}
                    tone="base"
                  />
                 <span>{intl.get("Sort")}</span>
                  </InlineStack>
                  </Button>
                  }
                  autofocusTarget="first-node"
                  onClose={()=>this.setState({popoverSort:false})}
                >
                  <OptionList
                  title=""
                  onChange={this.handleSelectChange}
                  options={sortOptions}
                  selected={[this.state.sortBy]}
                />
                </Popover>
                </div>
                </div>
              </div>
            </Card>}

            {/* 空数据显示 */}
            <div style={{position:'relative'}}>

              {EmptyProductList}
              
              <div className="Product__Loading" style={{display: (isSearching==='1' && ShowCountNumber===0)?'block':'none',backgroundColor:'unset'}}>
                <div className="Product__Loading_Image">
                  <img style={{width:'32px',height:'32px',verticalAlign:'middle'}} src='/loading.gif' alt="loading" />
                </div>
              </div>
            </div>

            {/* Start: 列表 */}
            <div style={{position:'relative', paddingTop:'2rem'}}>
              <section className="Product_Resource_Wrapper">
                <div className="Border_Mask Left"></div>
                <div className="Border_Mask Right"></div>
                <div className="Border_Mask Bottom"></div>

                <div className={"Product_Resource_Container " + smallSpacingClass}>
                  {/* 列表 div 对象 */}
                  {ListDivHtml}
                </div>
              </section>

              <div className="Product__Loading" style={{display: (isSearching === '1' && ShowCountNumber > 0)? 'block' : 'none'}}>
                <div className="Product__Loading_Image">
                  <img style={{width:'32px',height:'32px',verticalAlign:'middle'}} src='/loading.gif' alt="loading" />
                </div>
              </div>
            </div>
            {/* End: 列表 */}

            {/* 分页数据 */}
            {PaginationSettings}

          </Layout.Section>
        </Layout>
      </Page>
    )

    // 返回顶部按钮
    const RoundButton = (
      <Link onClick={this.scrollToTop}>
        <div className='top_position'>
            <div >
              <img  src={"/xiangshang.png"}  style={{width:"35px",height:"35px"}} alt="" />
            </div>
        </div>
      </Link> 
    )

    return (
      <div className='_my_product'>
        {pageContent}
        {toastMarkup}

        {!this.state.productAddSuccess && SingleOperationTipsModal}
        {/* dsm产品导入限制 */}
        <ImportDsmModal importOpen={this.state.importantDsmModal} num={this.state.importantDay} setImportOpen={()=>this.setState({importantDsmModal:false})}/>

        <div id='showTopButton'>
          {RoundButton}
        </div>
      </div>
    );
  }
}
// const mapStateToProps = state => {
//   return {
//     subScriptData: state.languageReducer.subScriptData
//   }
// }
export default withRouter(RecommendedCategory);